import { __decorate } from "tslib";
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from 'inversify';
import { workspaceApiUrlPrefix } from '@workspace/shared/constants/envConfig';
import _ from 'lodash';
let ExportPaperApiImpl = class ExportPaperApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: workspaceApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getExportPaperJob(data) {
        const result = await this.post({
            url: `/folder/${data.folderId}/export/paper`,
            data: _.omit(data, 'folderId'),
        });
        return result.data;
    }
};
ExportPaperApiImpl = __decorate([
    injectable()
], ExportPaperApiImpl);
export { ExportPaperApiImpl };
